class MapResultVM extends BaseResultVM {
    dataTable: [];
    dataSource: DevExpress.data.DataSource<any, any>;

    field: MapColumnInfo;
    metric: MapColumnInfo;

    currencyCode: string;

    maxValue: number;
    minValue: number;
    legendLength: number;

    customMaps: Array<string>;

    warningVisible: KnockoutObservable<boolean>;
    warningText: KnockoutObservable<string>;
    fieldLabel: KnockoutObservable<string>;
    attributeNameItems: KnockoutObservableArray<string>;

    dataSourceMapOptions: Array<any>;

    mapSettings: DevExpress.viz.dxVectorMap.Properties;
    mapComponent: DevExpress.viz.dxVectorMap;

    constructor(data) {
        super(data);

        this.dataTable = data.dataTable ?? [];
        this.field = new MapColumnInfo(data.field);
        this.metric = new MapColumnInfo(data.metric);

        this.currencyCode = data.currencyCode;
        this.maxValue = data.maxValue;
        this.minValue = data.minValue;
        this.legendLength = data.legendLength;
        this.customMaps = data.customMaps;

        this.warningVisible = ko.observable(false);
        this.warningText = ko.observable("");

        this.attributeNameItems = ko.observableArray(['name']);
        this.fieldLabel = ko.observable("Source");

        this.dataSourceMapOptions = [
            { id: MapDataSourceEnum.Africa.toString(), name: "Africa" },
            { id: MapDataSourceEnum.Canada.toString(), name: "Canada" },
            { id: MapDataSourceEnum.Europe.toString(), name: "Europe" },
            { id: MapDataSourceEnum.IrelandCounties.toString(), name: "Ireland - Counties" },
            { id: MapDataSourceEnum.USA.toString(), name: "USA" },
            { id: MapDataSourceEnum.USACities.toString(), name: "USA - Cities" },
            { id: MapDataSourceEnum.World.toString(), name: "World" }
        ];

        this.customMaps.forEach(function (this: MapResultVM, customMap) {
            if (!this.dataSourceMapOptions.find(x => x.id === customMap)) {
                this.dataSourceMapOptions.push({ id: customMap, name: customMap });
            }
        }.bind(this));
    }
}

class MapColumnInfo {
    index: number;
    queryName: string;
    autoGrouping: AutoGroupingEnum;
    groupingType: GroupingTypeEnum;
    dataType: DataTypeEnum;

    accountingStyle: boolean;
    decimalPlaces: number;
    metricFormat: FieldFormatEnum;

    constructor(data) {
        this.index = data.index;
        this.queryName = data.queryName;
        this.autoGrouping = data.autoGrouping;
        this.groupingType = data.groupingType;
        this.dataType = data.dataType;

        this.accountingStyle = data.accountingStyle;
        this.decimalPlaces = data.decimalPlaces;
        this.metricFormat = data.metricFormat;
    }
}